import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber, of } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { GroupRolePermissionDto, GroupRoleUserDto, UserGroupRoleDto } from '../models/GroupRole';
import { RouteInfo, ROUTES, ROUTES_0, ROUTES_1 } from '../models/IMenuItem';
import { PlatformGroupRoleDto, PlatformGroupRolePermissionDto, PlatformGroupRoleUserPermissionDto, UserPlatformGroupRoleDto } from '../models/PlatformGroupRoleDto';
import { ArchiveProjectDto, CloneProjectDto, ProjectDto, ProjectInfo, ProjectToAdd, UpdateProjectResponse, WPO2CreateProjectRequest, WPO2Project } from '../models/Project';
import { ProjectGroupRoleDto, ProjectGroupRoleForCreationDto } from '../models/projectgrouprole';
import { ProjectGroupRolePermissionDto, ProjectGroupRolePermissionForUpdateDto } from '../models/ProjectGroupRolePermission';
import { ProjectUserDto } from '../models/ProjectUser';
import { ProjectGroupRoleUser } from '../models/SquirrelRoles';
import { AvailableModulesItemCount, SubTenantDto, TenantDto, TenantGroupRoleDto, TenantGroupRoleUserDto, TenantScope, TenantToCreate, UserTenantDto } from '../models/TenantDto';
import { LoginInputModel, TenantUserPGR, UserDto, UserMinDto } from '../models/User';
import { BaseService } from './base.service';
import { EventsService } from './events.service';
import { OAuthServiceService } from './o-auth-service.service';
import { SquirrelSessionRequest, SquirrelSessionResponse } from '../models/SquirrelSession';
import { FoodNode } from '../models/ProjectTree';
import { TreeCheckedNode } from '../models/ProjectTreeChecked';
import { ApiTokenDto } from '../models/ApiToken';
import { AuditFilter, AuditDto } from '../models/AuditFilter';
import { FilenameRequest } from '../models/FilenameRequest';
import { PersonalFileInfo } from '../models/PersonalFileInfo';


@Injectable({ providedIn: 'root' })
export class TenantService extends BaseService {

  
  
  deleteUserRole(tenantdb: string, id: string, roleId: string) {
    throw new Error('Method not implemented.');
  }
    
  private readonly STORED_TENANT_DB  = 'tenant-db'
  private readonly STORED_CURRENT_DB = 'current-tenant-db';
  private readonly STORED_MENUITEMS = 'route-info'; 
  private readonly CURRENT_TENANT_ID = 'current-tenant-id'; 
  private readonly CURRENT_TENANT_NAME = 'current-tenant-name'; 
    // private readonly TEMP_TENANT_ID = 'temp-tenant-id'; 
    // private readonly TEMP_TENANT_NAME = 'temp-tenant-name'; 
  private readonly SM_MODE = 'lang-default';
  //private readonly CURRENT_FRONTENDURL = 'current-frontendurl'; 

  private TENANT_APPLICATION_TOKEN = '';

  private emptyProjId = '00000000-0000-0000-0000-000000000000';
  private userIdForConcat :string = "";

  private tokenMap = new Map<string, string>();

  private SystemManagerAbbrev = "SM";

  private PROJECTID!: string;
  private TENANTID!: string;
  private TEMPTENANT!: string;
  private TEMPUSERID!: string;

  private static _SMmode: boolean = false;

    
  constructor(
    private httpClient: HttpClient, 
    private oauthService: OAuthServiceService,
    private eventsService: EventsService) {
    super();
    this.oauthService.userData.subscribe({
      next: (data: any) => {
        if (typeof data != undefined && data != null) {
          //console.log("------> tenant-service userData: ", data)
          this.userIdForConcat = (data as any)?.sub + "_";
        }
      }
    });
  }

  // ngOnInit() {
  // }

  private  tokenExpired(token: string): boolean {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  // temporär gehaltene Daten
  getToken(tenant: string, forceCreate: boolean = false, projectId: string = this.emptyProjId) : Observable<string>{
    let token = this.tokenMap.get(this.userIdForConcat + this.currentTenantId + "_" + projectId);
    if (token == undefined || token == "" || this.tokenExpired(token) || forceCreate) {
      return this.createApplicationToken(tenant, projectId);
    } else {
      return of(token);
    }
  }
  storeToken(token: string, projectId: string = this.emptyProjId) {
    this.TENANT_APPLICATION_TOKEN = token;
    let key = this.userIdForConcat + this.currentTenantId + "_" + projectId;
    if (this.tokenMap.has(key))
      this.tokenMap.delete(key);
    this.tokenMap.set(key, token);
    // console.log("tenant.service store tokenMap: ", this.tokenMap)
  }

  removeToken(projectId: string = this.emptyProjId) {
    let key = this.userIdForConcat + this.currentTenantId + "_" + projectId;
    if (this.tokenMap.has(key))
      this.tokenMap.delete(key);
    //console.log("tenant.service remove tokenMap: ", this.tokenMap)

  }

  get ProjectUrl(): string {
    return this.projecturl;
  }

  get SystemManagerAbbreviation(): string {
    return this.SystemManagerAbbrev;
  }

  get projectId(): string {
    return this.PROJECTID;
  }
  set projectId(projId: string) {
    if(projId){
      this.PROJECTID=projId;
    }
    else{
      this.PROJECTID="";
    }
  }

  get tempTenant(): string {
    return this.TEMPTENANT;
  }
  set tempTenant(tenant: string) {
    if(tenant){
      this.TEMPTENANT=tenant;
    }
    else{
      this.TEMPTENANT="";
    }
  }

  get tempUserId(): string {
    return this.TEMPUSERID;
  }
  set tempUserId(userId: string) {
    if(userId){
      this.TEMPUSERID=userId;
    }
    else{
      this.TEMPUSERID="";
    }
  }


  // im local storage gehaltene Daten
  get SMmode(): boolean {
    // return localStorage.getItem(this.SM_MODE) === 'true';
    return TenantService._SMmode;
  }
  set SMmode(smMode: boolean) {
    TenantService._SMmode = smMode;
    // localStorage.setItem(this.SM_MODE, smMode.toString());
  }

  get currentTenantName(): string {
    return localStorage.getItem(this.CURRENT_TENANT_NAME) as string;
  }
  set currentTenantName(currentTenantName: string) {
    if(currentTenantName){
      localStorage.setItem(this.CURRENT_TENANT_NAME, currentTenantName);
      // localStorage.setItem(this.TEMP_TENANT_NAME, currentTenantName);
    }
    else{
      localStorage.removeItem(this.CURRENT_TENANT_NAME);
    }
    this.eventsService.currentTenantNameChanged.emit(currentTenantName);
  }

  get currentTenantId(): string {
    return localStorage.getItem(this.CURRENT_TENANT_ID) as string;
    //return this.TENANTID;
  }
  set currentTenantId(currentTenantId: string) {
    if(currentTenantId){
      localStorage.setItem(this.CURRENT_TENANT_ID, currentTenantId);
      // localStorage.setItem(this.TEMP_TENANT_ID, currentTenantId);
      //this.TENANTID = currentTenantId;
    }
    else{
      //this.TENANTID = "";
      localStorage.removeItem(this.CURRENT_TENANT_ID);
    }
    this.eventsService.currentTenantIdChanged.emit(currentTenantId);
    //this.eventsService.currentTenantIdChanged.emit(this.TENANTID);
  }

  // temporäre Tenant ist dann relevant und gesetzt, wenn man im Bereich SM arbeitet und für einen Tenant z.B. einen User erfasst
  get tempTenantName(): string {
    // return localStorage.getItem(this.TEMP_TENANT_NAME) as string;
    return localStorage.getItem(this.CURRENT_TENANT_NAME) as string;
  }
  set tempTenantName(tempTenantName: string) {
    if(tempTenantName){
      // localStorage.setItem(this.TEMP_TENANT_NAME, tempTenantName);
      localStorage.setItem(this.CURRENT_TENANT_NAME, tempTenantName);
    }
    else{
      // localStorage.removeItem(this.TEMP_TENANT_NAME);
      localStorage.removeItem(this.CURRENT_TENANT_NAME);
    }
    this.eventsService.tempTenantNameChanged.emit(tempTenantName);
  }

  get tempTenantId(): string {
    // return localStorage.getItem(this.TEMP_TENANT_ID) as string;
    return localStorage.getItem(this.CURRENT_TENANT_ID) as string;
  }
  set tempTenantId(tempTenantId: string) {
    if(tempTenantId){
      // localStorage.setItem(this.TEMP_TENANT_ID, tempTenantId);
      localStorage.setItem(this.CURRENT_TENANT_ID, tempTenantId);
    }
    else{
      // localStorage.removeItem(this.TEMP_TENANT_ID);
      localStorage.removeItem(this.CURRENT_TENANT_ID);
    }
    this.eventsService.tempTenantIdChanged.emit(tempTenantId);
    //this.eventsService.currentTenantIdChanged.emit(this.TENANTID);
  }

  // get currentFrontendUrl(): string {
  //   return localStorage.getItem(this.CURRENT_FRONTENDURL) as string;
  //   //return this.TENANTID;
  // }
  // set currentFrontendUrl(currentFrontendUrl: string) {
  //   if(currentFrontendUrl){
  //     localStorage.setItem(this.CURRENT_FRONTENDURL, currentFrontendUrl);
  //     //this.TENANTID = currentTenantId;
  //   }
  //   else{
  //     //this.TENANTID = "";
  //     localStorage.removeItem(this.CURRENT_FRONTENDURL);
  //   }
  //   //this.eventsService.currentTenantIdChanged.emit(currentTenantId);
  // }

  get defaultTenantdb() : string {
    return localStorage.getItem(this.STORED_TENANT_DB) as string;
  }
  set defaultTenantdb(defaultTenantdb: string) {
    if(defaultTenantdb){
      localStorage.setItem(this.STORED_TENANT_DB, defaultTenantdb);
    }
    else{
      localStorage.removeItem(this.STORED_TENANT_DB);
    }
    this.eventsService.defaultTenantdbChanged.emit(defaultTenantdb);
  }

  get currentTenantDb() : string {
    return localStorage.getItem(this.STORED_CURRENT_DB) as string;
  }
  set currentTenantDb(currentTenantDb: string) {
    if(currentTenantDb){
      localStorage.setItem(this.STORED_CURRENT_DB, currentTenantDb);
    }
    else{
      localStorage.removeItem(this.STORED_CURRENT_DB);
    }
    this.eventsService.currentTenantDbChnaged.emit(currentTenantDb);
  }

  get menuItems() : RouteInfo[] {
    return JSON.parse(localStorage.getItem(this.STORED_MENUITEMS) as string);
  }
  set menuItems(menuItems: RouteInfo[]) {
    if(menuItems) {
      //localStorage.setItem(this.STORED_MENUITEMS, JSON.stringify(menuItems));
    }
    else{
      //localStorage.removeItem(this.STORED_MENUITEMS);
    }
    this.eventsService.menuItemsChanged.emit(menuItems);
  }

  getDefaultRouteInfo(db:string) {
    //  if(db === 'squirrel')
    if(db === 'admin'){
      this.changeMenuItems(ROUTES);
    }
    else {
      this.changeMenuItems(ROUTES_0);
    }
  }
  changeMenuItems(menuItems: RouteInfo[]) {
    this.menuItems = menuItems;
  }

  // getDefaultTenancy() {
  //   this.httpClient.get<string>(`${this.tenantUsers}/GetDefaultTenancy`)
  //   .subscribe({
  //     next: (defaultTenantdb:string) => {
  //       if(defaultTenantdb.length > 0){
  //         this.changeTenant(defaultTenantdb);
  //       }
  //       else{
  //          this.changeTenant('admin');
  //         //this.changeTenant('squirrel');
  //       }        
  //     }
  //   });
  // }
  // changeTenant(tenantdb:string) {
  //    this.defaultTenantdb = tenantdb;     
  // }

  // getSelectedTenant(): TenantDto {
  //   //return this.httpClient.get<TenantDto>(`${this.tenants}/${id}`);
  //   return new TenantDto();
  // }

  // changeCurrentTenantDb(currentTenantDb: string){
  //   this.currentTenantDb = currentTenantDb;
  // }

  // Requests mit User Token
  isTenantExisting(tenantName: string): Observable<boolean> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<boolean>(`${this.tenants}/IsTenantExisting/${tenantName}`, {headers: headers});
  }
  createTenancy(tenant: TenantToCreate): Observable<TenantDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<TenantDto>(`${this.tenants}/AddTenant`, tenant, {headers: headers});
  }
  updateUserTenancy(userTenant: UserTenantDto) : Observable<UserTenantDto>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.put<UserTenantDto>(`${this.tenants}/UpdateUserTenancy`, userTenant, { headers: headers });
  }
  setUserTenancyLocked(tenantName: string, tenantId: string, userId: string, locked: boolean): Observable<boolean> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
        return this.httpClient.put<boolean>(`${this.tenants}/SetUserTenancyLocked/${tenantName}/${tenantId}/${userId}`, locked, { headers: headers });
  }
  deleteTenancy(id: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.delete<any>(`${this.tenants}/DeleteTenant/${id}`, {headers: headers});
  }
  getTenants(genericFilter: GenericFilter): Observable<TenantDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<TenantDto[]>(`${this.tenants}/GetFilteredTenants?genericFilter=genericFilter`, genericFilter, { headers: headers });
  }
  getTenantsByScope(scope: string): Observable<TenantDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<TenantDto[]>(`${this.tenants}/GetTenantsByScope/${scope}`, { headers: headers });
  }
  getTenant(id: string): Observable<TenantDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<TenantDto>(`${this.tenants}/GetTenant/${id}`, { headers: headers });
  }
  getUserTenants(genericFilter: GenericFilter): Observable<TenantDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<TenantDto[]>(`${this.tenants}/GetFilteredUserTenants?genericFilter=genericFilter`, genericFilter, { headers: headers });
  }
  updateTenancy(tenant: TenantDto): Observable<TenantDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
     return this.httpClient.put<TenantDto>(`${this.tenants}/UpdateTenant`, tenant, {headers: headers});
  }

  // decreaseNumberTenantModules(tenantId: string, moduleIds: string[]): Observable<boolean> {
  //   const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
  //    return this.httpClient.put<boolean>(`${this.tenants}/DecreaseNumberTenantModules/${tenantId}`, moduleIds, {headers: headers});
  // }

    decreaseNumberTenantModules(tenantName: string,tenantId: string, moduleIds: string[]): Observable<boolean> {
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantName).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<boolean>(`${this.tenants}/DecreaseNumberTenantModules/${tenantId}`, moduleIds, {headers: headers}).subscribe ({
            next:(result) => {
              subscriber.next(result);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }


    // increaseNumberTenantModules(tenantId: string, moduleIds: string[]): Observable<boolean> {
    //   const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //    return this.httpClient.put<boolean>(`${this.tenants}/IncreaseNumberTenantModules/${tenantId}`, moduleIds, {headers: headers});
    // }

  increaseNumberTenantModules(tenantName: string,tenantId: string, moduleIds: string[]): Observable<boolean> {
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantName).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<boolean>(`${this.tenants}/IncreaseNumberTenantModules/${tenantId}`, moduleIds, {headers: headers}).subscribe ({
            next:(result) => {
              subscriber.next(result);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }


  
  deleteUserTenancy(userTenant: UserTenantDto) : Observable<any> {
    // return this.httpClient.delete<any>(`${this.tenantUsers}/${userId}/DeleteUserTenancy?tenantName=${tenantName}/${tenantId}`);
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<any>(`${this.tenantUsers}/DeleteUserTenancy`, userTenant, {headers: headers});
  }


  getUsersInTenancy(tenantdb: string, genericFilter: GenericFilter) : Observable<UserDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserDto[]>(`${this.tenantUsers}/GetFilteredUsersInTenancy?genericFilter=genericFilter&tenantdb=${tenantdb}`, genericFilter, { headers: headers });
  }
  getUserTenantz(userId: string, genericFilter: GenericFilter) : Observable<UserTenantDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<UserTenantDto[]>(`${this.tenantUsers}/${userId}/GetFilteredUserTenancies?genericFilter=genericFilter`, genericFilter, { headers: headers })
  }
  getTenantGroupRoles(tenantdb:string, genericFilter: GenericFilter) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`).set('dbname', tenantdb);
    return this.httpClient.post<TenantGroupRoleDto[]>(`${this.tenantgrouproles}/GetFilteredTenantGroupRoles/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers})
  }
  getUserTenant() : Observable<UserTenantDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserTenantDto>(`${this.tenantUsers}/GetUserTenancy`, { headers: headers });
  }
  getTenantUsers(tenantdb:string, genericFilter: GenericFilter): Observable<UserDto[]> {
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<UserDto[]>(`${this.tenantUsers}/GetFilteredTenantUsers/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers});

    var self = this;
    return new Observable<UserDto[]>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<UserDto[]>(`${this.tenantUsers}/GetFilteredTenantUsers/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
            next:(users) => {
              subscriber.next(users);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }
  getUser(tenantdb: string, id: string) : Observable<UserDto> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserDto>(`${this.tenantUsers}/${id}/GetUser/${tenantdb}`, {headers: headers});
  }
  loadTenantUsers(tenantdb: string, searchText: string, page: number, pageSize: number) : Observable<UserDto[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.get<UserDto[]>(`${this.tenantUsers}?searchText=${searchText}&page=${page}&pageSize=${pageSize}&tenantdb=${tenantdb}`, {headers: headers});
  }

  updateUser(tenantdb:string, userToUpdate: UserMinDto) : Observable<boolean>{
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // //const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TENANT_APPLICATION_TOKEN}`);
    // return this.httpClient.put<UserDto>(`${this.tenantUsers}/UpdateTenantUser/${tenantdb}`, userToUpdate, { headers: headers });

    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<boolean>(`${this.tenantUsers}/UpdateTenantUser/${tenantdb}`, userToUpdate, { headers: headers }).subscribe ({
            next:(user) => {
              subscriber.next(user);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });


  } 

  updateUserConfirmed(tenantdb:string, userToUpdate: UserDto) : Observable<UserDto>{
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // //const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TENANT_APPLICATION_TOKEN}`);
    // return this.httpClient.put<UserDto>(`${this.tenantUsers}/UpdateTenantUserConfirmed/${tenantdb}`, userToUpdate, { headers: headers });
    var self = this;
    return new Observable<UserDto>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<UserDto>(`${this.tenantUsers}/UpdateTenantUserConfirmed/${tenantdb}`, userToUpdate, { headers: headers }).subscribe ({
            next:(user) => {
              subscriber.next(user);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  } 

  updateUserNames(tenantdb:string, userToUpdate: UserDto) : Observable<UserDto>{
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TENANT_APPLICATION_TOKEN}`);
    return this.httpClient.put<UserDto>(`${this.tenantUsers}/UpdateUserNames/${tenantdb}`, userToUpdate, { headers: headers });
  } 

  deleteUser(tenantdb: string, tenantid: string, id: any) {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    //const headers = new HttpHeaders().set('Authorization', `Bearer ${this.TENANT_APPLICATION_TOKEN}`);
    return this.httpClient.delete<any>(`${this.tenantUsers}/${id}/${tenantdb}/${tenantid}`, { headers: headers });
  }

  checkPassword(login: LoginInputModel) {
    //let identityUrl = "https://localhost:44310/Account";
    // let login = new LoginInputModel();
    // login.email = "test22@web.de";
    // login.password = "Te$t12345";
    // console.log("-----> checkPassword() - login = ", login);
    return this.httpClient.post<any>(`${this.identityAccount}/CheckLogin`, login);
  }

  migrateWPO2Projects1(tenant: string,request: WPO2CreateProjectRequest): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`);
    return this.httpClient.post<any>(`${this.tenantProjects}/GetMigrateableWPO2Projects/${tenant}`, request, { headers: headers });
  }

  migrateWPO2Projects(tenant: string,request: WPO2CreateProjectRequest ) : Observable<ProjectDto[]>{
    var self = this;
    return new Observable<ProjectDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectDto[]>(`${this.tenantProjects}/MigrateWPO2Projects/${tenant}`, request, { headers: headers }).subscribe ({
            next:(projectInfo) => {
              subscriber.next(projectInfo);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }




  getProjectInfos(tenant: string, projectId:string ) : Observable<ProjectInfo>{
    var self = this;
    return new Observable<ProjectInfo>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<ProjectInfo>(`${this.tenantProjects}/GetProjectInfos/${projectId}`, { headers: headers }).subscribe ({
            next:(projectInfo) => {
              subscriber.next(projectInfo);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<ProjectDto[]>(`${this.tenantProjects}/GetFilteredProjects/${tenantdb}?genericFilter=genericFilter`, genericFilter, { headers: headers });
  }
  // Requests mit Application Token (TODO teilweise noch zu ändern hier und auf Controller Seite)
  getServers(tenant: string, tenantScope: string) : Observable<string[]> {
    var self = this;
    return new Observable<string[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<string[]>(`${this.tenantProjects}/GetServers/${tenantScope}`, { headers: headers }).subscribe ({
            next:(servers) => {
              subscriber.next(servers);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getScopes(tenant: string) : Observable<TenantScope[]> {
    var self = this;
    return new Observable<TenantScope[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<TenantScope[]>(`${this.tenantProjects}/GetScopes/${tenant}`, { headers: headers }).subscribe ({
            next:(scopes) => {
              subscriber.next(scopes);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  addProject(project: ProjectToAdd, tenant: string) : Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectDto>(`${this.tenantProjects}/AddProject/${tenant}`, project, { headers: headers }).subscribe ({
            next:(project) => {
              subscriber.next(project);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

    addProjectWithGrouproles(project: ProjectToAdd, tenant: string ): Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectDto>(`${this.tenantProjects}/AddProjectWithGrouproles/${tenant}`, project, { headers: headers }).subscribe ({
            next:(project) => {
              subscriber.next(project);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  updateProject(project: ProjectDto, tenant: string) : Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectDto>(`${this.tenantProjects}/${project.id}/${tenant}`, project, {headers: headers}).subscribe ({
            next:(project) => {
              subscriber.next(project);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  deleteProject(tenant: string, project: ProjectDto) : Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<ProjectDto>(`${this.tenantProjects}/DeleteProject/${project.id}/${tenant}`, { headers: headers }).subscribe ({
            next:(project) => {
              subscriber.next(project);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.delete<ProjectDto>(`${this.tenantProjects}/DeleteProject/${project.id}/${tenantdb}`, { headers: headers });
  }

  getTenantProjects(tenant: string, genericFilter: GenericFilter) : Observable<ProjectDto[]> {
    var self = this;
    return new Observable<ProjectDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);

          //test
          //token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjA4NTMzNmFmZTY0Yzg2ZWQ3NDU5YzE5YzQ4ZjQzNzI3IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE3MjQ3NjY3OTQsImV4cCI6MTcyNDc2Nzk5NCwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NDQzMTAiLCJzdWIiOiJmZGZjNDFmMC02ZWRlLTRmY2MtYTcyNy0zZWI5MzhlZTQ3NDkiLCJwbGF0Zm9ybVVybCI6Imh0dHBzOi8vbG9jYWxob3N0OjQ0Mzc5IiwidGVuYW50IjoiQUFST04iLCJ0ZW5hbnRQZXJtaXNzaW9uIjpbImFkbWluIiwiYWRtaW5pc3RyYXRpb24iLCJjcmVhdGVfdGVuYW50IiwiQ1JFQVRFX1VTRVIiLCJNQU5BR0VfVVNFUlMiLCJDUkVBVEVfUFJPSkVDVCIsIk1BTkFHRV9QUk9KRUNUUyIsIkNSRUFURV9ERU1PVVNFUiIsImxpc3RQcm9qZWN0cyJdLCJwcm9qZWN0X2lkIjoiMDAwMDAwMDAtMDAwMC0wMDAwLTAwMDAtMDAwMDAwMDAwMDAwIiwicHJvamVjdFBlcm1pc3Npb24iOiJzaG93UHJvamVjdCIsInVzZXJfaWQiOiJmZGZjNDFmMC02ZWRlLTRmY2MtYTcyNy0zZWI5MzhlZTQ3NDkiLCJ1c2VyIjoidy5ob3R6QGFsYmVydC1pbmcuY29tIiwidXNlcl9uYW1lIjoiV2FsdGVyIEguIEhvdHoiLCJjbGllbnRfaWQiOiJzcXVpcnJlbGNsaWVudCIsImF1ZCI6WyJ0ZW5hbnRzbWljcm9zZXJ2aWNlQXBpIiwicHJvamVjdHNtaWNyb3NlcnZpY2VBcGkiXSwic2NvcGUiOlsidGVuYW50c21pY3Jvc2VydmljZSIsInByb2plY3RzbWljcm9zZXJ2aWNlIl19.ZiuXEkuNjJzhGr0oDclHobMi3_cE7wbUfQBkUApn5qwwuG6DPIl2kDlyatxNEbkBn4CyK55P8vOQz5Rqv2sL_5tfMiYumo-hAqr8NppHbUJt-qZsAb0SfC2IoE-yu-k-swwM9LBUxodAYRnz8fjMzEVD-3DrwYMMEjThApjdb9Yg8opYbBHGM6pS4ezK_EdDrz-zi7lwK1ACSRFHOx_iDd_FHSe1jvHdTiXvmGPcdtpsIH-nl0lTeq8Kl0INTHgOZNhczmLGoRgSJqwR7CkNd66Vw4U1zrFq8J8UnWlOd5I86AQDYBM0OdbdE61BMqs4CxLkSUzxccFrfEZ2GT_EWA"

          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectDto[]>(`${self.tenantProjects}/GetFilteredTenantProjects?genericFilter=genericFilter&tenantdb=${tenant}`, genericFilter, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }
  
  getUserProjects(genericFilter: GenericFilter, tenant:string): Observable<ProjectDto[]> {
    //console.log("---------> getUserProjects")
    var self = this;
    return new Observable<ProjectDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          //console.log("---------> getFilteredUserProjects")
//          for test: self.httpClient.get<ProjectDto[]>(`https://localhost:44379/api/tokenservice/GetRefreshToken/${tenant}`, {headers: headers}).subscribe ({
            self.httpClient.post<ProjectDto[]>(`${self.tenantProjects}/GetFilteredUserProjects?genericFilter=genericFilter&tenantdb=${tenant}`, genericFilter, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getProjectImageMesse(tenant: string, projectId: string, callback: { (result: any): void; (arg0: Blob): void; }){
    var self = this;
    //if (!self.authenticationService.user) return;

    // self.getToken(tenant).subscribe({
    //   next: (token: string) => {
        // self.storeToken(token);
        let token = this.tokenMap.get(this.userIdForConcat + this.currentTenantId + "_" + this.emptyProjId);

        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'image/jpeg');
        headers.append('responseType', 'blob');
        const options: any = {headers: headers, observe: 'response',
        reportProgress: false,
        responseType: 'blob',
        withCredentials: false
  };
    
    
        this.httpClient.get(`${this.tenantProjects}/GetProjectImageMesse/${projectId}`, options).subscribe(data => {
          const result = data as any;
          var resultData = result.body as Blob;
          if (callback && resultData) callback(resultData);
          },
          error => {
            console.log("-------> tenantService error=", error)
          }
        );
    //   },
    //   error: (error: any) => {
    //     console.log("--------> tenantService.getProjectImage error",error)
    //   }
    // });
  }






  // getProjectImage(tenant: string, projectId: string) : Observable<any> {
  //   var self = this;
  //   return new Observable<any>((subscriber)=>{
  //     self.getToken(tenant).subscribe({
  //       next: (token) => {
  //         self.storeToken(token);
  //         const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //         headers.append('Content-Type', 'image/jpeg');
  //         headers.append('responseType', 'blob');
  //         const options: any = {headers: headers, observe: 'response',
  //         reportProgress: false,
  //         responseType: 'blob',
  //         withCredentials: false
  //         };
  //         //console.log("--------> tenantService.getProjectImage headers=", headers)
  //         self.httpClient.get<any>(`${this.tenantProjects}/GetProjectImage/${projectId}`, options).subscribe ({
  //           next:(data) => {
  //             //console.log("--------> tenantService.getProjectImage next")
  //             const result = data as any;
  //             var img = result.body as Blob;
      
  //             subscriber.next(img);
  //           },
  //           // complete:() => {
  //           //   console.log("--------> tenantService.getProjectImage complete")
  //           //   subscriber.complete();
  //           // },
  //           error: (error: any) => {
  //             //console.log("--------> tenantService.getProjectImage error",error)
  //             subscriber.error(error);
  //           }
  //         });
  //     },
  //       error: (error: any) => {
  //         //console.log("--------> tenantService.getProjectImage error",error)
  //         subscriber.error(error);
  //       }
  //     })
  //   });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.delete<ProjectDto>(`${this.tenantProjects}/DeleteProject/${project.id}/${tenantdb}`, { headers: headers });
  // }

  getTenantProject(tenant: string, projectId: string): Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<ProjectDto>(`${this.tenantProjects}/${projectId}/GetProject/${tenant}`, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  loadProjectUsers(tenant: string, projectId: string, genericFilter: GenericFilter) : Observable<ProjectUserDto[]> {
    var self = this;
    return new Observable<ProjectUserDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectUserDto[]>(`${this.tenantProjects}/${projectId}/GetFilteredProjectUsers/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  GetAvailableModules(tenant: string, genericFilter: GenericFilter) : Observable<AvailableModulesItemCount[]> {
    var self = this;
    return new Observable<AvailableModulesItemCount[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<AvailableModulesItemCount[]>(`${this.tenantProjects}/GetAvailableModules`, {headers: headers}).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  cloneProject(tenant: string, cloneProject: CloneProjectDto): Observable<ProjectDto> {
    var self = this;
    return new Observable<ProjectDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectDto>(`${this.tenantProjects}/CloneProject/${tenant}`, cloneProject, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.getToken(tenant)}`);
    // return this.httpClient.post<ProjectDto>(`${this.tenantProjects}/CloneProject/${tenant}`, cloneProject, { headers: headers });
  }

  archiveProject(tenant: string, archiveProject: ArchiveProjectDto): Observable<boolean> {
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<boolean>(`${this.tenantProjects}/ArchiveProject/${tenant}`, archiveProject, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.getToken(tenant)}`);
    // return this.httpClient.post<ProjectDto>(`${this.tenantProjects}/CloneProject/${tenant}`, cloneProject, { headers: headers });
  }


  updateProjectDB(tenant: string, projectId: string): Observable<UpdateProjectResponse> {
    var self = this;
    return new Observable<UpdateProjectResponse>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.get<UpdateProjectResponse>(`${this.tenantProjects}/UpdateProjectDatabase/${projectId}`, { headers: headers }).subscribe ({
            next:(response) => {
              subscriber.next(response);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.getToken(tenant)}`);
    // return this.httpClient.post<ProjectDto>(`${this.tenantProjects}/CloneProject/${tenant}`, cloneProject, { headers: headers });
  }
  getProjectGroupRoles(projectId: string, tenant: string, genericFilter: GenericFilter) : Observable<ProjectGroupRoleDto[]> {
    var self = this;
    return new Observable<ProjectGroupRoleDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto[]>(`${this.tenantProjectGroupRoles}/${projectId}/GetFilteredProjectGroupRoles/${tenant}`, genericFilter, { headers: headers }).subscribe ({
            next:(projects) => {
              subscriber.next(projects);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });     
  }

  getProjectGroupRoleTemplates(tenant: string, genericFilter: GenericFilter) : Observable<ProjectGroupRoleDto[]> {
    var self = this;
    return new Observable<ProjectGroupRoleDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto[]>(`${this.tenantProjectGroupRoles}/GetProjectGroupRoleTemplates/${tenant}`, genericFilter, { headers: headers }).subscribe ({
            next:(templates) => {
              subscriber.next(templates);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });     
  }

  getProjectGroupRoleTemplatesForAdmin(tenant: string, genericFilter: GenericFilter) : Observable<ProjectGroupRoleDto[]> {
    var self = this;
    return new Observable<ProjectGroupRoleDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto[]>(`${this.tenantProjectGroupRoles}/GetProjectGroupRoleTemplatesForAdmin/${tenant}`, genericFilter, { headers: headers }).subscribe ({
            next:(templates) => {
              subscriber.next(templates);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });     
  }

  checkForGroupRoleUsers(tenant: string, roleId: string, projectId: string, genericFilter: GenericFilter) :Observable<any> {
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<any>(`${this.tenantProjectGroupRoles}/${roleId}/CheckIfThereGroupRoleUsers/${projectId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(usersExist) => {
              subscriber.next(usersExist);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<any>(`${this.tenantProjectGroupRoles}/${roleId}/CheckIfThereGroupRoleUsers/${projectId}/${tenantdb}`, genericFilter, {headers: headers});
  }

  deleteRole(tenant: string, id: string) : Observable<any>{
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<any>(`${this.tenantProjectGroupRoles}/${id}/DeleteProjectGroupRole/${tenant}`, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  } 

  deleteRoleTemplate(tenant: string, id: string) : Observable<any>{
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<any>(`${this.tenantProjectGroupRoles}/${id}/DeleteProjectGroupRoleTemplate/${tenant}`, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  } 
  createProjectGroupRole(projectGroupRole: ProjectGroupRoleForCreationDto, tenant: string) : Observable<ProjectGroupRoleForCreationDto> {
    var self = this;
    return new Observable<ProjectGroupRoleForCreationDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleForCreationDto>(`${this.tenantProjectGroupRoles}/AddProjectGroupRole/${tenant}`, projectGroupRole, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  } 

  createProjectGroupRoleTemplate(projectGroupRole: ProjectGroupRoleDto, tenant: string) : Observable<ProjectGroupRoleDto> {
    var self = this;
    return new Observable<ProjectGroupRoleDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/AddProjectGroupRoleTemplate/${tenant}`, projectGroupRole, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  updateProjectGroupRole(projectId: string, tenant: string, groupRole: ProjectGroupRoleDto) : Observable<ProjectGroupRoleDto> {
    var self = this;
    return new Observable<ProjectGroupRoleDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/${projectId}/UpdateGroupRoleById/${tenant}`, groupRole, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  updateProjectGroupRoleTemplate(tenant: string, groupRole: ProjectGroupRoleDto) : Observable<ProjectGroupRoleDto> {
    var self = this;
    return new Observable<ProjectGroupRoleDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/UpdateGroupRoleTemplateById/${tenant}`, groupRole, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  createProjectGroupRoleUser(projectGroupRoleUser: ProjectGroupRoleUser, tenant: string) : Observable<ProjectGroupRoleUser> {
    var self = this;
    return new Observable<ProjectGroupRoleUser>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleUser>(`${this.tenantProjectGroupRoles}/CreateProjectGroupRoleUser/${tenant}`, projectGroupRoleUser, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<ProjectGroupRoleUser>(`${this.tenantProjectGroupRoles}/ProjectGroupRoleUser/${tenantdb}`, projectGroupRoleUser, {headers: headers});
  }

  checkForTenantGroupRoleUsers(tenant: string, roleId: string, genericFilter: GenericFilter) :Observable<any> {
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<any>(`${this.tenantgrouproles}/${roleId}/CheckIfThereTenantGroupRoleUsers/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(usersExist) => {
              subscriber.next(usersExist);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<any>(`${this.tenantProjectGroupRoles}/${roleId}/CheckIfThereGroupRoleUsers/${projectId}/${tenantdb}`, genericFilter, {headers: headers});
  }

  fetchTenantGroupRoleUsers(tenant: string, projectId: string, roleId: string, genericFilter: GenericFilter) : Observable<GroupRoleUserDto[]> {   
    var self = this;
    return new Observable<GroupRoleUserDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<GroupRoleUserDto[]>(`${this.tenantProjectGroupRoles}/${projectId}/GetFilteredGroupRoleUsers/${roleId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(role) => {
              console.log("fetch Header: ", headers);
              console.log("----------------------> : ", role);
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  GetTenantUserPGRList(tenant: string, projectId: string, roleId: string, genericFilter: GenericFilter) : Observable<TenantUserPGR[]> {   
    var self = this;
    return new Observable<TenantUserPGR[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<TenantUserPGR[]>(`${this.tenantProjectGroupRoles}/${projectId}/GetTenantUserPGRList/${roleId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(users) => {
              console.log("fetch Header: ", headers);
              subscriber.next(users);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getUserProjectsAndGrouproles(tenant: string, userId: string) : Observable<FoodNode[]> {   
    var self = this;
    return new Observable<FoodNode[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          let la = headers.getAll('lazyUpdate');
          // let headers = new HttpHeaders();
          // headers = headers.set('Authorization', `Bearer ${token}`);
          // headers = headers.set('Content-Type', 'application/json');
        
          self.httpClient.post<FoodNode[]>(`${this.tenantProjectGroupRoles}/GetUserProjectsGroupRoles/${userId}/${tenant}`, new GenericFilter(), {headers: headers}).subscribe ({
            next:(node) => {
              console.log("foodNode Header nachher: ", headers);
              subscriber.next(node);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getUserProjectsAndGrouprolesChecked(tenant: string, userId: string) : Observable<TreeCheckedNode[]> {   
    var self = this;
    return new Observable<TreeCheckedNode[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        
         self.httpClient.post<TreeCheckedNode[]>(`${this.tenantProjectGroupRoles}/GetUserProjectsGroupRolesChecked/${userId}/${tenant}`, new GenericFilter(), {headers: headers}).subscribe ({
            next:(node) => {
              subscriber.next(node);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getAllTenantProjectGroupRoleTemplatesChecked(tenant: string) : Observable<TreeCheckedNode[]> {   
    var self = this;
    return new Observable<TreeCheckedNode[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        
          self.httpClient.post<TreeCheckedNode[]>(`${this.tenantProjectGroupRoles}/GetAllTenantProjectGroupRoleTemplatesChecked/${tenant}`, new GenericFilter(), {headers: headers}).subscribe ({
            next:(node) => {
              subscriber.next(node);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

  getTenantProjectGroupRoleTemplatesChecked(tenant: string) : Observable<TreeCheckedNode[]> {   
    var self = this;
    return new Observable<TreeCheckedNode[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        
          self.httpClient.post<TreeCheckedNode[]>(`${this.tenantProjectGroupRoles}/GetTenantProjectGroupRoleTemplatesChecked/${tenant}`, new GenericFilter(), {headers: headers}).subscribe ({
            next:(node) => {
              subscriber.next(node);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }

    getProjectGroupRoleTemplate(roleId: string, tenant: string, genericFilter: GenericFilter) : Observable<ProjectGroupRoleDto> {
    var self = this;
    return new Observable<ProjectGroupRoleDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/GetGroupRoleTemplateById/${roleId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
  }


  getProjectGroupRole(projectId: string, roleId: string, tenant: string, genericFilter: GenericFilter) : Observable<ProjectGroupRoleDto> {
    var self = this;
    return new Observable<ProjectGroupRoleDto>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/${projectId}/GetFilteredGroupRoleById/${roleId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<ProjectGroupRoleDto>(`${this.tenantProjectGroupRoles}/${projectId}/GetFilteredGroupRoleById/${roleId}/${tenantdb}`, genericFilter, {headers: headers});
  }

  deleteUserFromGroupRole(tenant: string, projectId: any, roleId: any, userId: any) : Observable<any> {
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          console.log("-----> deleteUserFromRole - headers: ", headers)
          self.httpClient.delete<any>(`${this.tenantProjectGroupRoles}/${userId}/DeleteGroupRoleUser/${projectId}/${roleId}/${tenant}`, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  copyUserGroupRole(tenant: string, copyProjectId: any, targetProjectId: any, userName: any) : Observable<any> {
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          // let headers = new HttpHeaders({
          //   'Authorization': `Bearer ${token}`,
          //   'Content-Type': 'application/json',
          // });
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('Content-Type', 'application/json');
          console.log("-----> copyUserRole - headers: ", headers)
          self.httpClient.post<any>(`${this.tenantProjectGroupRoles}/${copyProjectId}/CopyProjectGroupRoles/${targetProjectId}/${userName}/${tenant}`, {headers: headers}).subscribe ({
              next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  deleteUserFromTenantGroupRole(tenant: string, roleId: any, userId: any) : Observable<any> {
    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<any>(`${this.tenantgrouproles}/${userId}/DeleteTenantGroupRoleUser/${roleId}/${tenant}`, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.delete<any>(`${this.tenantProjectGroupRoles}/${userId}/GroupRoleUser/${projectId}/${roleId}/${tenantdb}`, {headers: headers});

  loadUserGroupRoles(tenant: string, userId: any, projectId: any, genericFilter: GenericFilter): Observable<UserGroupRoleDto[]> {
    var self = this;
    return new Observable<UserGroupRoleDto[]>((subscriber)=>{
      self.getToken(tenant).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<UserGroupRoleDto[]>(`${this.tenantProjects}/${userId}/GetFilteredUserGroupRoles/${projectId}/${tenant}`, genericFilter, {headers: headers}).subscribe ({
            next:(roles) => {
              subscriber.next(roles);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });
     
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return this.httpClient.post<UserGroupRoleDto[]>(`${this.tenantProjects}/${userId}/GetFilteredUserGroupRoles/${projectId}/${tenantdb}`, genericFilter, {headers: headers});
  }

  // noch nicht zugeordnete Requests
  // loadTenants(searchText: any, page?: number, pageSize?: number): Observable<TenantDto[]> {
  //   return this.httpClient.get<TenantDto[]>(`${this.tenants}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  // } 

  // fetchSubTenants(searchText: any, page: number, pageSize: number) : Observable<TenantDto[]> {
  //   return this.httpClient.get<TenantDto[]>(`${this.tenants}/GetSubTenancies?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  // } 

  // getSubTenants(genericFilter: GenericFilter) : Observable<SubTenantDto[]> {
  //   return this.httpClient.post<SubTenantDto[]>(`${this.tenants}/GetFilteredSubTenants?genericFilter=genericFilter`, genericFilter);
  // }

  // createUserTenancy(userTenant: UserTenantDto) : Observable<UserTenantDto>{
  //   return this.httpClient.post<UserTenantDto>(`${this.tenantUsers}/UserTenancy`, userTenant);
  // }

  // getDashboardUserProjects(genericFilter: GenericFilter): Observable<ProjectDto[]> {
  //   return this.httpClient.post<ProjectDto[]>(`${this.tenantProjects}/GetFilteredDashboardUserProjects?genericFilter=genericFilter`, genericFilter);
  // }

  

  // createSubTenancy(tenantdb: string, tenant: SubTenantDto) : Observable<TenantDto> {
  //   return this.httpClient.post<TenantDto>(`${this.tenants}/CreateSubTenancy/${tenantdb}`, tenant);
  //  }

  //   createSubTenancy(tenantdb: string, subTenant: string) : Observable<TenantDto> {
  //   return this.httpClient.get<TenantDto>(`${this.tenants}/CreateSubTenancy/${subTenant}`);
  // }

  loadGroupRolePermissions(roleId: string, tenantdb: string)  : Observable<GroupRolePermissionDto[]> {
    return this.httpClient.get<GroupRolePermissionDto[]>(`${this.tenantGroupRolePermissions}/${roleId}/${tenantdb}`);
  }

  updateGroupRolePermission(groupRolePermission: GroupRolePermissionDto, tenantdb: string) : Observable<GroupRolePermissionDto> {
    return this.httpClient.put<GroupRolePermissionDto>(`${this.tenantGroupRolePermissions}/${tenantdb}`, groupRolePermission);
  }

  createProjectGroupRolePermission(projectGroupRolePermission: ProjectGroupRolePermissionForUpdateDto, tenantdb: string) : Observable<ProjectGroupRolePermissionDto> {
    return this.httpClient.post<ProjectGroupRolePermissionDto>(`${this.tenantProjectGroupRolePermissions}/${tenantdb}`, projectGroupRolePermission);
  }

  getProjectUserPermissions(projectId: any, tenantdb: string) : Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.tenantProjectGroupRolePermissions}/${projectId}/GetProjectUserPermissions/${tenantdb}`);
  }

  // getGetUserIds(roleId: string, tenantdb: string) : Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${this.tenantProjectRoles}/${roleId}/GetUserIds/${tenantdb}`);
  // }
  
  /// Platform-Group-Roles
  // getUserPlatformGroupRoles(tenantdb:string, userId: string, genericFilter: GenericFilter) {
  //   return this.httpClient.post<UserPlatformGroupRoleDto[]>(`${this.tenantplatformGroupRoles}/${userId}/GetUserFilteredPlatformGroupRoles?genericFilter=genericFilter&tenantdb=${tenantdb}`, genericFilter)
  // }

/// Tenant-Group-Roles

  getUserTenantGroupRoles(tenantdb:string, userId: string, genericFilter: GenericFilter) {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', tenantdb);

    return this.httpClient.post<TenantGroupRoleDto[]>(`${this.tenantgrouproles}/GetTenantGroupRolesForUser/${userId}/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers})
  }
  
  createTenantGroupRole(tenantdb:string, groupRole: TenantGroupRoleDto) {
    // const headers = new HttpHeaders()
    // .set('Authorization', `Bearer ${this.oauthService.token}`)
    // .set('dbname', tenantdb);
    // return this.httpClient.put<TenantGroupRoleDto>(`${this.tenantgrouproles}/CreateTenantGroupRole/${tenantdb}`, groupRole, {headers: headers})

    var self = this;
    return new Observable<TenantGroupRoleDto>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.put<TenantGroupRoleDto>(`${this.tenantgrouproles}/CreateTenantGroupRole/${tenantdb}`, groupRole, {headers: headers}).subscribe ({
            next:(role) => {
              subscriber.next(role);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }
      
  createTenantGroupRoleUser(tenantdb:string, groupRoleUser: TenantGroupRoleUserDto) {
    // const headers = new HttpHeaders()
    // .set('Authorization', `Bearer ${this.oauthService.token}`)
    // .set('dbname', tenantdb);
    // return this.httpClient.post<TenantGroupRoleUserDto>(`${this.tenantgrouproles}/TenantGroupRoleUser/${tenantdb}`, groupRoleUser, {headers: headers})

    var self = this;
    return new Observable<TenantGroupRoleUserDto>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<TenantGroupRoleUserDto>(`${this.tenantgrouproles}/TenantGroupRoleUser/${tenantdb}`, groupRoleUser, {headers: headers}).subscribe ({
            next:(user) => {
              subscriber.next(user);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }
        
  updateTenantGroupRole(tenantdb:string, groupRole: TenantGroupRoleDto) {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', tenantdb);
    return this.httpClient.put<TenantGroupRoleDto>(`${this.tenantgrouproles}/UpdateTenantGroupRole/${tenantdb}`, groupRole, {headers: headers})
    }
  
    getTenantGroupRole(tenantdb:string, roleId: string, genericFilter: GenericFilter) {
      const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', tenantdb);
      return this.httpClient.post<TenantGroupRoleDto>(`${this.tenantgrouproles}/GetTenantGroupRoleById/${roleId}/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers})
    }
  
    deleteTenantGroupRole(tenantdb:string, roleId: string) {
      // const headers = new HttpHeaders()
      // .set('Authorization', `Bearer ${this.oauthService.token}`)
      // .set('dbname', tenantdb);
      // return this.httpClient.delete<TenantGroupRoleDto>(`${this.tenantgrouproles}/DeleteTenantGroupRoleById/${roleId}/${tenantdb}?genericFilter=genericFilter`, {headers: headers})

    var self = this;
    return new Observable<any>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<TenantGroupRoleDto>(`${this.tenantgrouproles}/DeleteTenantGroupRoleById/${roleId}/${tenantdb}?genericFilter=genericFilter`, {headers: headers}).subscribe ({
            next:(success) => {
              subscriber.next(success);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

    }
  
  
  createProjectSession(squirrelSessionRequest: SquirrelSessionRequest): Observable<SquirrelSessionResponse> {
    return this.httpClient.post<SquirrelSessionResponse>(`${this.tenantProjects}/CreateSession`, squirrelSessionRequest);
  }

  createApplicationToken(tenantdb: string, projectid: any  = this.emptyProjId): Observable<string> {
    var self = this;
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', tenantdb);
    return new Observable<string>((subscriber)=>{
      self.httpClient.post<string>(`${this.tenantapplicationtokens}/CreateApplicationToken/${tenantdb}/${projectid}`, null, {headers: headers}).subscribe ({
          next:(token) => {
          self.storeToken(token);

          subscriber.next(token);
        },
        complete:() => {
          subscriber.complete();
        },
        error: (error: any) => {
          subscriber.error(error);
        }
      });
    });
  

  }

  createApplicationTokenId(tenantdb: string, projectid: any  = this.emptyProjId): Observable<string> {
    var self = this;
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', tenantdb);
    return new Observable<string>((subscriber)=>{
      self.httpClient.post<string>(`${this.tenantapplicationtokens}/CreateApplicationTokenId/${tenantdb}/${projectid}`, null, {headers: headers}).subscribe ({
        next:(tokenId) => {
          subscriber.next(tokenId);
        },
        complete:() => {
          subscriber.complete();
        },
        error: (error: any) => {
          subscriber.error(error);
        }
      });
    }); 
  }

  createApiTokenRecord(tenantdb: string, apiToken: ApiTokenDto): Observable<boolean> {
    // var self = this;
    // const headers = new HttpHeaders()
    // .set('Authorization', `Bearer ${this.oauthService.token}`)
    // .set('dbname', tenantdb);
    // return new Observable<boolean>((subscriber)=>{
    //   self.httpClient.post<boolean>(`${this.tenantapplicationtokens}/CreateApiTokenRecord/${tenantdb}`, apiToken, {headers: headers}).subscribe ({
    //     next:(tokenIdSaved) => {
    //       subscriber.next(tokenIdSaved);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });

    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<boolean>(`${this.tenantapplicationtokens}/CreateApiTokenRecord/${tenantdb}`, apiToken, {headers: headers}).subscribe ({
            next:(tokenIdSaved) => {
              subscriber.next(tokenIdSaved);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });


  }

  getAllApiTokens(tenantdb:string, genericFilter: GenericFilter): Observable<ApiTokenDto[]> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<ApiTokenDto[]>((subscriber)=>{
    //   self.httpClient.post<ApiTokenDto[]>(`${this.tenantapplicationtokens}/GetFilteredAllApiTokens/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
    //     next:(tokenRecs) => {
    //       subscriber.next(tokenRecs);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });

    var self = this;
    return new Observable<ApiTokenDto[]>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ApiTokenDto[]>(`${this.tenantapplicationtokens}/GetFilteredAllApiTokens/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
            next:(tokenRecs) => {
              subscriber.next(tokenRecs);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });


  }

  getApiTokens(tenantdb:string, userid:string, genericFilter: GenericFilter): Observable<ApiTokenDto[]> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<ApiTokenDto[]>((subscriber)=>{
    //   self.httpClient.post<ApiTokenDto[]>(`${this.tenantapplicationtokens}/GetFilteredApiTokens/${tenantdb}/${userid}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
    //     next:(tokenRecs) => {
    //       subscriber.next(tokenRecs);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<ApiTokenDto[]>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<ApiTokenDto[]>(`${this.tenantapplicationtokens}/GetFilteredApiTokens/${tenantdb}/${userid}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
            next:(tokenRecs) => {
              subscriber.next(tokenRecs);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  deleteApiToken(tenantdb:string, id:string): Observable<boolean> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<boolean>((subscriber)=>{
    //   self.httpClient.delete<boolean>(`${this.tenantapplicationtokens}/DeleteApiToken/${tenantdb}/${id}`, {headers: headers}).subscribe ({
    //     next:(tokenRecs) => {
    //       subscriber.next(tokenRecs);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.delete<boolean>(`${this.tenantapplicationtokens}/DeleteApiToken/${tenantdb}/${id}`, {headers: headers}).subscribe ({
            next:(rc) => {
              subscriber.next(rc);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  // Audit Log

  exportAuditLog(tenantdb:string, auditFilter: AuditFilter): Observable<boolean> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<boolean>((subscriber)=>{
    //   self.httpClient.post<boolean>(`${this.tenantAudit}/ExportAuditLog/${tenantdb}?auditFilter=auditFilter`, auditFilter, {headers: headers}).subscribe ({
    //     next:(rc) => {
    //       subscriber.next(rc);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<boolean>(`${this.tenantAudit}/ExportAuditLog/${tenantdb}?auditFilter=auditFilter`, auditFilter, {headers: headers}).subscribe ({
            next:(rc) => {
              subscriber.next(rc);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

}

    getFilteredAuditLog(tenantdb:string, genericFilter: GenericFilter): Observable<AuditDto[]> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<AuditDto[]>((subscriber)=>{
    //   self.httpClient.post<AuditDto[]>(`${this.tenantAudit}/GetFilteredAuditLog/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
    //     next:(auditRecs) => {
    //       subscriber.next(auditRecs);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });

    var self = this;
    return new Observable<AuditDto[]>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<AuditDto[]>(`${this.tenantAudit}/GetFilteredAuditLog/${tenantdb}?genericFilter=genericFilter`, genericFilter, {headers: headers}).subscribe ({
            next:(auditRecs) => {
              subscriber.next(auditRecs);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });


  }

  // Download files
  getPersonalFiles(tenantdb:string, reqData: FilenameRequest): Observable<PersonalFileInfo[]> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<PersonalFileInfo[]>((subscriber)=>{
    //   self.httpClient.post<PersonalFileInfo[]>(`${this.tenantfiles}/GetPersonalFiles/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
    //     next:(files) => {
    //       subscriber.next(files);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<PersonalFileInfo[]>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<PersonalFileInfo[]>(`${this.tenantfiles}/GetPersonalFiles/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
            next:(files) => {
              subscriber.next(files);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  createPersonalDownloadToken(tenantdb:string, reqData: FilenameRequest): Observable<string> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<string>((subscriber)=>{
    //   self.httpClient.post<string>(`${this.tenantfiles}/CreatePersonalFileDownloadToken/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
    //     next:(token) => {
    //       subscriber.next(token);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<string>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<string>(`${this.tenantfiles}/CreatePersonalFileDownloadToken/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
            next:(token) => {
              subscriber.next(token);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  deletePersonalFile(tenantdb:string, reqData: FilenameRequest): Observable<boolean> {
    // var self = this;
    // const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
    // return new Observable<boolean>((subscriber)=>{
    //   self.httpClient.post<boolean>(`${this.tenantfiles}/DeletePersonalFile/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
    //     next:(result) => {
    //       subscriber.next(result);
    //     },
    //     complete:() => {
    //       subscriber.complete();
    //     },
    //     error: (error: any) => {
    //       subscriber.error(error);
    //     }
    //   });
    // });
    var self = this;
    return new Observable<boolean>((subscriber)=>{
      self.getToken(tenantdb).subscribe({
        next: (token) => {
          self.storeToken(token);
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          self.httpClient.post<boolean>(`${this.tenantfiles}/DeletePersonalFile/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
            next:(result) => {
              subscriber.next(result);
            },
            complete:() => {
              subscriber.complete();
            },
            error: (error: any) => {
              subscriber.error(error);
            }
          });
      },
        error: (error: any) => {
          subscriber.error(error);
        }
      })
    });

  }

  // deletePersonalFiles(tenantdb:string, reqData: FilenameRequest): Observable<boolean> {
  //   var self = this;
  //   const headers = new HttpHeaders().set('Authorization', `Bearer ${this.oauthService.token}`);
  //   return new Observable<boolean>((subscriber)=>{
  //     self.httpClient.post<boolean>(`${this.tenantfiles}/DeletePersonalFiles/${tenantdb}?reqData=reqData`, reqData, {headers: headers}).subscribe ({
  //       next:(result) => {
  //         subscriber.next(result);
  //       },
  //       complete:() => {
  //         subscriber.complete();
  //       },
  //       error: (error: any) => {
  //         subscriber.error(error);
  //       }
  //     });
  //   });
  // }

  getPersonalFileDownloadUrl(token: string): string {  
      return (`${this.tenantfiles}/DownloadPersonalFile/${token}`);
  }



  getTenantRoles(token: string) : string[] {

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const dataJWT = JSON.parse(window.atob(base64));
    var roles = dataJWT.tenantPermission;
    return roles;
  }

}
